import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";


const Id = (cell) => {
  return cell.value ? cell.value : '';
};

const LinkCell = (cell) => {
  return (
    <Link className="text-dark fw-medium" to="#">{cell.value}</Link>
  );
};

const Date = (cell) => {
  return cell.value ? moment(cell.value).format("MMM DD, YYYY") : '';
};

const CaseTypeName = (cell) => {
  return cell.value;
};
const CommonCell = (cell) => {
  return cell.value ? cell.value : '';
};
const Amount = (cell) => {
  return cell.value != '' ? "$" + cell.value : '';
};


export {
  Amount, CaseTypeName, CommonCell,
  Date
};
